export const translateBool = (bool: boolean | null) => (bool ? 'Ja' : 'Nein');
